"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonCircleBoldIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var PersonCircleBold = function PersonCircleBold(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm6.134 17.9a.749.749 0 01-.634.35h-11a.75.75 0 01-.677-1.072 6.834 6.834 0 0112.354 0 .748.748 0 01-.043.722zM12 4.35a3.7 3.7 0 11-3.7 3.7 3.7 3.7 0 013.7-3.7z"
  }));
};
PersonCircleBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const PersonCircleBoldIcon = exports.PersonCircleBoldIcon = (0, _createIconComponent.default)(PersonCircleBold, 'PersonCircleBold');